(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-logo-marquee"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('brand-marquee')) {
    class BrandMarquee extends HTMLElement {
      constructor() {
        super();
        this.step = this.step.bind(this);
        this.onPointerDown = this.onPointerDown.bind(this);
        this.onPointerMove = this.onPointerMove.bind(this);
        this.onPointerUp = this.onPointerUp.bind(this);
        this.onClickCapture = this.onClickCapture.bind(this);
        this.onResize = this.onResize.bind(this);
        this.pause = this.pause.bind(this);
        this.resume = this.resume.bind(this);
      }

      connectedCallback() {
        this.track = this.querySelector('[data-brand-marquee-track]');
        if (!this.track) return;

        this.speed = Math.max(parseFloat(this.dataset.speed) || 30, 1);
        this.direction = this.dataset.direction === 'right' ? 1 : -1;
        this.pauseOnHover = this.dataset.pauseOnHover !== 'false';
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.offset = 0;
        this.repeat = 0;
        this.velocity = 0;
        this.paused = false;
        this.dragging = false;
        this.moved = false;
        this.visible = true;

        this.originals = Array.prototype.slice.call(this.track.children);
        if (this.originals.length === 0) return;

        this.bind();

        if (this.reduced) return;

        // Wait for logos to load so widths are measured correctly.
        const images = this.querySelectorAll('img');
        const pending = Array.prototype.filter.call(images, (img) => !img.complete);

        if (pending.length === 0) {
          this.start();
        } else {
          let remaining = pending.length;
          const done = () => {
            remaining -= 1;
            if (remaining <= 0) this.start();
          };
          pending.forEach((img) => {
            img.addEventListener('load', done, { once: true });
            img.addEventListener('error', done, { once: true });
          });
          // Safety net in case an image never fires.
          setTimeout(() => {
            if (!this.started) this.start();
          }, 2500);
        }
      }

      disconnectedCallback() {
        this.stop();
        window.removeEventListener('resize', this.onResize);
        if (this.observer) this.observer.disconnect();
      }

      start() {
        if (this.started) return;
        this.started = true;
        this.build();
        this.watch();
        this.play();
      }

      build() {
        this.track.querySelectorAll('[data-brand-marquee-clone]').forEach((node) => node.remove());

        const styles = window.getComputedStyle(this.track);
        const gap = parseFloat(styles.columnGap || styles.gap) || 0;
        const setWidth = this.track.getBoundingClientRect().width;

        this.repeat = setWidth + gap;
        if (this.repeat <= 0) return;

        const copies = Math.min(Math.ceil((this.offsetWidth + this.repeat) / this.repeat), 12);
        const fragment = document.createDocumentFragment();

        for (let i = 0; i < copies; i += 1) {
          this.originals.forEach((node) => {
            const clone = node.cloneNode(true);
            clone.setAttribute('data-brand-marquee-clone', '');
            clone.setAttribute('aria-hidden', 'true');
            if (clone.tagName === 'A') clone.setAttribute('tabindex', '-1');
            clone.querySelectorAll('a').forEach((a) => a.setAttribute('tabindex', '-1'));
            fragment.appendChild(clone);
          });
        }

        this.track.appendChild(fragment);
        this.render();
      }

      watch() {
        window.addEventListener('resize', this.onResize);

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              this.visible = entry.isIntersecting;
              if (this.visible) this.play();
              else this.stop();
            });
          });
          this.observer.observe(this);
        }

        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.stop();
          else if (this.visible) this.play();
        });
      }

      onResize() {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => {
          this.offset = 0;
          this.build();
        }, 250);
      }

      bind() {
        this.addEventListener('pointerdown', this.onPointerDown);
        this.addEventListener('pointermove', this.onPointerMove);
        this.addEventListener('pointerup', this.onPointerUp);
        this.addEventListener('pointercancel', this.onPointerUp);
        this.addEventListener('click', this.onClickCapture, true);
        this.addEventListener('dragstart', (event) => event.preventDefault());

        if (this.pauseOnHover) {
          this.addEventListener('mouseenter', this.pause);
          this.addEventListener('mouseleave', this.resume);
        }

        this.addEventListener('focusin', this.pause);
        this.addEventListener('focusout', this.resume);
      }

      pause() {
        this.paused = true;
      }

      resume() {
        this.paused = false;
      }

      play() {
        if (this.raf || this.reduced || !this.started) return;
        this.last = performance.now();
        this.raf = requestAnimationFrame(this.step);
      }

      stop() {
        if (!this.raf) return;
        cancelAnimationFrame(this.raf);
        this.raf = null;
      }

      step(now) {
        const delta = Math.min((now - this.last) / 1000, 0.05);
        this.last = now;

        if (!this.dragging) {
          if (Math.abs(this.velocity) > 8) {
            this.offset += this.velocity * delta;
            this.velocity *= Math.pow(0.0025, delta);
          } else {
            this.velocity = 0;
            if (!this.paused) this.offset += this.direction * this.speed * delta;
          }
          this.render();
        }

        this.raf = requestAnimationFrame(this.step);
      }

      render() {
        if (this.repeat > 0) {
          let value = this.offset % this.repeat;
          if (value > 0) value -= this.repeat;
          this.offset = value;
        }
        this.track.style.transform = 'translate3d(' + this.offset + 'px, 0, 0)';
      }

      onPointerDown(event) {
        if (this.reduced || event.button > 0) return;

        this.dragging = true;
        this.moved = false;
        this.velocity = 0;
        this.startX = event.clientX;
        this.lastX = event.clientX;
        this.lastTime = performance.now();
        this.startOffset = this.offset;
        this.classList.add('is-dragging');

        if (this.setPointerCapture) {
          try {
            this.setPointerCapture(event.pointerId);
          } catch (error) {
            /* no-op */
          }
        }
      }

      onPointerMove(event) {
        if (!this.dragging) return;

        const distance = event.clientX - this.startX;
        if (Math.abs(distance) > 4) this.moved = true;
        if (!this.moved) return;

        event.preventDefault();

        const now = performance.now();
        const elapsed = (now - this.lastTime) / 1000;
        if (elapsed > 0) {
          this.velocity = (event.clientX - this.lastX) / elapsed;
        }

        this.lastX = event.clientX;
        this.lastTime = now;
        this.offset = this.startOffset + distance;
        this.render();
      }

      onPointerUp() {
        if (!this.dragging) return;

        this.dragging = false;
        this.classList.remove('is-dragging');
        this.velocity = Math.max(Math.min(this.velocity, 2200), -2200);

        // If the flick was gentle, hand straight back to the auto-scroll.
        if (Math.abs(this.velocity) < 60) this.velocity = 0;
      }

      onClickCapture(event) {
        if (!this.moved) return;
        event.preventDefault();
        event.stopPropagation();
        this.moved = false;
      }
    }

    customElements.define('brand-marquee', BrandMarquee);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
